<template>
    <div class="">
        <card>
             <template v-slot:header>
                <h4 class="d-inline">پیامکــ ـهای آماده</h4>
                <hr>
            </template>
            <template v-slot:content>
                <div class="mb-3">
                  <a v-if="AddMode == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = 1" title="افزودن پیامک جدید جدید">
                    <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
                  </a>
                  <a v-if="AddMode != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = 0;Reload()" title="لغو افزودن">
                    <h4><i class="fas fa-times text-danger"></i></h4>
                  </a>
                </div>
                <div v-if="AddMode !=0" >
                    <div class="row mt-5" :id="$route.name">
                        <div class="col-md-3 col-12 text-right">
                            <div class="row">
                                <div class="col-12 text-right">
                                    <small id="LblOnvan">عنوان پیامک</small>
                                    <input
                                        v-model="Model.Onvan"
                                        type="text"
                                        @keypress="$ValidPersian($event, 40)"
                                        id="Vcode"
                                        class="form-control InputText text-right required"
                                        style="direction: ltr"/>
                                </div>
                                <div class="col-12 text-right mt-2">
                                    <small id="LblParams">انتخــاب پارامتر</small>
                                    <select class="form-control" @change="ParamsSelected($event)">
                                        <option value="">-- پارامتر را انتخاب کنید --</option>
                                        <option v-for="(item, key) in ListParameters" :key="key" :value="item" >
                                        {{ item }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-success px-2 mt-4 w-100" v-if="AddMode==1" @click="SetSmsTemp">ثبت پیامک</button>
                                    <button class="btn btn-warning px-2 mt-4 w-100" v-else @click="EditSmsTemp">ویرایش پیامک</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-9 col-12 text-right border-right">
                            <small id="LblMatnSms">متن پیامــک</small>
                            <textarea class="form-control w-100 mt-2" rows="7" v-model="Model.MatnSms"></textarea>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <BnpGrid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true">
                        <template slot="action-slot" slot-scope="props">
                            <a  href="javascript:;" class="mr-2 badge"  @click="OnEditNew(props.props);"><h5><span class="fas fa-marker text-secondary hover-warning" ></span ></h5></a>
                            <a  href="javascript:;" class="mr-2 badge" v-if="props.props.Id!=455056" @click="OnDelete(props.props);" title="حذف"><h5><span class="fad fa-trash hover-danger"></span></h5></a>
                        </template>
                    </BnpGrid>
                </div>
            </template>
        </card>
    </div>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import BnpGrid from '../../components/BnpGrid/BnpGrid.vue';
import Card from '../../components/Card/Card.vue';
export default {
  components: { Card, BnpGrid, VuePersianDatetimePicker },
    data(){
        return{ 
            Column:[],
            Rows:[],
            AddMode:0,
            Model:{
                Id: 0,
                TblShobeId: 1,
                TblSoftwareId: 2,
                Onvan: "",
                MatnSms: "",
                TblComboSysIdNoe1: 0,
                SendInZaman: null,
                SendSaliyaneRozMah: null,
                ZamanInsert: "",
                TblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
                ZamanLastEdit: "",
                TblUserGrpIdLastEdit: 0,
                InfoDes: "",
                SendInZamanPrg: "",
                tblComboSysIdSMSNoe2: 0,
            },
            CopyModel:{}
        }
    },
    methods: {
        GetRows(){
           let DataAxiosSearch= { ArryfildValue: { ShobeId: 1, SoftwareId: 2 } }
           DataAxiosSearch.Action = "SmsTemplate/GetSmsTemplateInCRM";
           DataAxiosSearch.Method = "post";
           this.$PostData(DataAxiosSearch).then((result)=>{
                if (result.Status=="Ok"){
                    this.Rows=result.Data;

                }
           }).finally(()=>{
              this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true;
                });
           })
        },
        GetColumn(){
             let DataAxoisColumns= {
                ArryfildValue: {
                    SoftwareId: 2,
                    UserId: 1,
                    FormName: "frmSmsTemplate",
                    ShowView: 0,
                },
                Method: "post",
                Action: "ReadGridColumns",
            }
            this.$GetColumns(DataAxoisColumns, true)
            .then((data) => {
                this.Column=data;
            })
            .finally(()=>{
                this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true;
                });
            });
        },
         GetParametrs() {
                this.ListParameters = [
                    "[نام مشتری]",
                    "[کد مشتری]",
                    "[نام ,نام خانوادگی پرسنل]",
                    "[شماره موبایل پرسنل]",
                    "[نام کاربری CRM پرسنل]",
                    "[کلمه عبور CRM پرسنل]",
                    "[تاریخ امروز]",
                    "[بدهی مشتری]",
                ];
        },
        ParamsSelected(e) {
            this.Model.MatnSms += e.target.value;
        },
        SetSmsTemp(){

            if(this.$ValidForm(this.$route.name) == false){
                return
            }

            let DataAxios_Data={
                    ArryfildValue: {},
                    Method: "Post",
                    Action: 'SmsTemplate',
                    Token: this.$session.get("Token"),
                }
                DataAxios_Data.ArryfildValue=this.Model
                this.$PostData(DataAxios_Data)
                .then(data=>{
                    if (data.status=="Ok") {
                        this.GetRows();
                        this.AddMode=0
                    }
                    else{
                        if (data.eNum==547) {
                             console.error(data);
                        }
                    }
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
        },
        EditSmsTemp(){
            if(this.$ValidForm(this.$route.name) == false){
                return
            }
            let DataAxios_Data={
                    ArryfildValue: {},
                    Method: "put",
                    Action: 'SmsTemplate',
                    Token: this.$session.get("Token"),
                }
                this.Model.TblUserGrpIdLastEdit=this.$session.get("UserInfo").tblUserGrpId
                DataAxios_Data.ArryfildValue=this.Model
                this.$PostData(DataAxios_Data)
                .then(data=>{
                    if (data.status=="Ok") {
                        this.$SetLog(DataAxios_Data.ArryfildValue, 0)
                        this.GetRows();
                        this.AddMode=0;
                    }
                    else{
                        if (data.eNum==547) {
                             console.error(data);
                        }
                    }
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
        },
        OnEditNew(row){
            this.$store.state.OldDataForLog = JSON.stringify(row)
            this.Model=row
            this.AddMode=-1
        },
        OnDelete(row){
            this.$store.state.OldDataForLog = JSON.stringify(row)
            let DataAxios_Data={
                    ArryfildValue: {},
                    Method: "delete",
                    Action: 'SmsTemplate/DeleteSmsTemplate',
                    Token: this.$session.get("Token"),
                }
                DataAxios_Data.ArryfildValue.Id=row.Id
                this.$PostData(DataAxios_Data)
                .then(data=>{
                    // console.log(data);
                    if (data.status=="Ok") {
                        this.$toasted.success('پیام آماده با موفقیت حذف گردید',{durations:2000})
                        this.$SetLog(DataAxios_Data.ArryfildValue, 1)
                        this.GetRows();
                        this.$store.state.renderComponentGrid=false
                        this.$nextTick(()=>{
                            this.$store.state.renderComponentGrid = true;
                        })
                    }
                    else{
                        if (data.eNum==547) {
                             console.error(data);
                        }
                    }
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
        },
        Reload(){
            this.Model=this.CopyModel
        }
    },
    mounted() {
        this.GetRows();
        this.GetColumn();
    },
    created(){
        this.CopyModel=JSON.parse(JSON.stringify(this.Model))
        this.GetParametrs();
    }
}
</script>
<style scoped>

</style>